import styled from 'styled-components';

export const Input = styled.input<{ invalid?: boolean }>`
  width: 100%;
  display: block;
  border: 1px solid ${({ invalid }) => (invalid ? '#d90429' : '#ececec')};
  background-color: #f7f9fb;
  border-radius: 10px;
  font-size: 20px;
  padding: 15px;
  margin: 15px 0 15px 0;

  :focus {
    outline: none !important;
  }

  ::placeholder {
    font-size: 20px;
    color: #444444;
  }
`;
